import { createContext } from "react";
import { FormFactor } from "../types/enums/FormFactor";

export const FormFactorContext = createContext<FormFactor>(FormFactor.Desktop);
